import React from 'react';

import NeighborhoodScreen from '..';
import {TModal} from "../../../../../types/common.type";
import {locationNamespace} from "../../../../../types/location.namespace";
import {useQuery, UseQueryResult} from "react-query";
import values from "../../../../../values";
import api from "../../../../../api";
import Context from "../../../../../context";
import successHandler from "../../../../../utils/successHandler";

const NeighborhoodContainer: React.FC = (): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const [showModal, setShowModal] = React.useState<TModal>('NONE');
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [selectedNeighborhood, setSelectedNeighborhood] = React.useState<locationNamespace.neighborhood.index | undefined>(undefined);
  const [requestNeighborhood , setRequestNeighborhood ] = React.useState<locationNamespace.neighborhood.request>({
    limit: 10,
    page : 1 ,
  });

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // ! =================================================================================================================
  // ! ------------------------------------------------ Start Call API -------------------------------------------------

  const getCities: UseQueryResult<any, unknown> = useQuery(
    [values.useQueryKeys.locationGetNeighborhood, requestNeighborhood],
    () => api.get.common.searchNeighborhood(requestNeighborhood)
  );

  // ! ------------------------------------------------- End Call API --------------------------------------------------
  // ! =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  async function createFunction(event: locationNamespace.neighborhood.create): Promise<void> {
    setIsLoading(true);
    const result = await api.post.administrator.createNeighborhood(event);
    successHandler(result?.CODE);
    await getCities.refetch();
    setShowModal('NONE');
    setIsLoading(false);
  }

  async function updateFunction(event: locationNamespace.neighborhood.update): Promise<void> {
    setIsLoading(true);
    if (!selectedNeighborhood) return;
    const result = await api.patch.administrator.updateNeighborhood(selectedNeighborhood?._id, event);
    successHandler(result?.CODE);
    await getCities.refetch();
    setShowModal('NONE');
    setIsLoading(false);
  }

  async function deleteFunction(): Promise<void> {
    setIsLoading(true);
    if (!selectedNeighborhood) return;
    const result = await api.dele.administrator.deleteNeighborhood(selectedNeighborhood?._id);
    successHandler(result?.CODE);
    await getCities.refetch();
    setShowModal('NONE');
    setIsLoading(false);
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <Context.Location.Neighborhood.Provider value={{
      showModal           ,
      isLoading           ,
      requestNeighborhood ,
      selectedNeighborhood,
      setShowModal           ,
      createFunction         ,
      updateFunction         ,
      deleteFunction         ,
      setRequestNeighborhood ,
      setSelectedNeighborhood,
    }}>
      <NeighborhoodScreen rqData={getCities} />
    </Context.Location.Neighborhood.Provider>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================
}

export default NeighborhoodContainer;
